export const prefix = 'mg'
